<template>
  <div class="home">
    <el-row :gutter="20">
      <el-col :span="12" :offset="6" :xs="{ span: 24, offset: 0 }">
        <h2>Увод</h2>

        <p>
          Добродошли у интерактивни водич кроз саобраћај. Упустите се у мноштво
          реалних примера који на крајње интересантан начин имају за циљ да
          допринесу већој свести о важности познавања саобраћајних прописа.
          Едукација младих је један од најважнијих циљева Обазривка, који је још
          увек у фази развоја, тако да молимо вас за било какву повратну
          информацију о проблемима на које сте наишли или захтевима за даљи
          развој
          <a href="mailto:obazrivko@gmail.com">(obazrivko@gmail.com)</a>.
        </p>

        <h2>Корисни материјали</h2>

        <h3>Документи</h3>

        <ul>
          <li>
            <a
              href="https://drive.google.com/file/d/1-T9Dowaw7wvrSUBBEUmqjvQ5_gn3o96X/view"
              target="__blank"
              >Корисничко упутство (кратак водич кроз функционалности апликације)</a
            >
          </li>
          <li>
            <a
              href="/static/docs/pravilnik_o_saobracajnoj_signalizaciji.pdf"
              target="__blank"
              >Правилник о саобраћајној сигнализацији (PDF)</a
            >
          </li>
        </ul>

        <h3>Линкови</h3>

        <ul>
          <li>
            <a
              href="http://osraska.nasaskola.rs/strana/78/SAOBRACAJNA-SEKCIJA/"
              target="__blank"
              >Материјали и тестови са претходних такмичења "Шта знаш о
              саобраћају"</a
            >
          </li>
          <li>
            <a
              href="https://www.mgsi.gov.rs/cir/dokumenti/bezbednost-saobratshaja"
              target="__blank"
              >Подзаконски акти о безбедности саобраћаја</a
            >
          </li>
          <li>
            <a href="http://www.abs.gov.rs/" target="__blank"
              >Агенција за безбедност саобраћаја</a
            >
          </li>
          <li>
            <a href="http://www.amss.org.rs/" target="__blank"
              >Ауто-мото савез Србије</a
            >
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Info",
};
</script>

<style lang="scss" scoped>
p {
  text-align: justify;
}
</style>
